import React, { Component } from "react";
import { Container, Row, Col, Card, Carousel, Image, Nav, Tab, Form, Button } from 'react-bootstrap'
import { Link } from "react-router-dom"

import { withRouter } from "react-router-dom";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import client from "../../apolloClient";
import VignanLogin from "./VignanLogin";
import { isVignanContext } from "../utils/vignan";
import { getFirstAccessibleRoute } from "../../moduleAccessGuard";
import { resolveUserScope } from "../../utils/dataScope";

import "../../_login.scss";

const GET_ORGANISATION_PROFILE = gql`
  query($institution_id: Int!) {
    getOrganisationProfile(institution_id: $institution_id) {
      id
      complete_address
      logo
    }
  }
`;

const GET_ROLE_MODULE_ACCESS = gql`
  query($institute_id: Int, $employee_role_id: Int) {
    getRoleModuleAccess(institute_id: $institute_id, employee_role_id: $employee_role_id) {
      module_id
      module_name
      module_key
      sub_module_name
      is_view
      is_edit
      is_delete
    }
  }
`;

// Main college (institute admin) modules: the college's enabled modules for this
// employee_type at this institute. Used to build the admin sidebar from
// employee_type_id + institute_id rather than the raw module_access JSON.
const GET_MODULES_BY_EMPLOYEE_TYPE = gql`
  query($institute_id: Int, $employee_type_id: Int) {
    getModulesByEmployeeType(institute_id: $institute_id, employee_type_id: $employee_type_id) {
      module_id
      module_name
      display_name
      is_view
    }
  }
`;

const LOGIN_USER = gql`
  mutation($username: String!, $password: String!) {
    login1(username: $username, password: $password) {
      token
      refreshToken
      user {
        username
        userlevel
        email
        mobile
        valid
        name
        institution_id
        institute_name
        module_access
        subject_ids
        class_ids
        section_ids
        branch_id
        employee_role_id
        id
      }
    }
  }
`;


class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      username: "",
      password: "",
      submitError: "",
      formErrors: {
        username: "",
        password: ""
      },
      usernameValid: false,
      passwordValid: false,
      formValid: false,
      loader: 0,
      showPassword: false
    };
  }
  togglePasswordVisibility = () => {
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };
  handleFormSubmit = e => {
    e.preventDefault();
    this.setState({
      loader: 1
    });
    console.log("Form submitted");
    console.log(this.state);

    if (this.state.formValid) {
      console.log("college login", this.state.username, this.state.password);
      this.login1(this.state.username, this.state.password).catch(error => {
        console.log("catch if error");
        console.log(error);
        this.setState({
          submitError: error.graphQLErrors.map(x => x.message), loader: 0
        });
        console.error(
          "ERR =>",
          error.graphQLErrors.map(x => x.message)
        );
      });
    } else {
      this.setState({ submitError: "Please fill all the values to proceed", loader: 0 });
    }
  };
  login1 = async (username, password) => {
    const result = await this.props.login1({
      variables: {
        username,
        password
      },
      update: (store, { data }) => {
        Cookies.set("token", data.login1.token);
        Cookies.set("refreshtoken", data.login1.refreshToken);
        Cookies.set("username", data.login1.user.username);
        Cookies.set("name", data.login1.user.name);
        Cookies.set("email", data.login1.user.email);
        Cookies.set("id", data.login1.user.id);
        Cookies.set("institutionid", data.login1.user.institution_id);
        Cookies.set("role", "institution");
        Cookies.set("institutename", data.login1.user.institute_name);

        // Cookies.set(
        //     "fullname",
        //     data.login.user.firstname + " " + data.login.user.lastname
        // );
        Cookies.set("userlevel", data.login1.user.userlevel);
        localStorage.setItem("moduleRestrictions", JSON.stringify(data.login1.user.module_access))
      }
    });

    // After mutation completes, set branch_id from the backend natively
    const userData = result.data.login1.user;
    Cookies.set("branch_id", String(userData.branch_id || ""));
    Cookies.set("class_ids", String(userData.class_ids || ""));
    Cookies.set("section_ids", String(userData.section_ids || ""));
    Cookies.set("subject_ids", String(userData.subject_ids || ""));
    Cookies.set("employee_role_id", String(userData.employee_role_id || ""));
    await resolveUserScope(client, userData);

    // Fetch role-based module access for this user's branch + role and cache it
    try {
      const accessResult = await client.query({
        query: GET_ROLE_MODULE_ACCESS,
        variables: {
          institute_id: parseInt(userData.institution_id),
          employee_role_id: userData.employee_role_id ? parseInt(userData.employee_role_id) : null,
        },
        fetchPolicy: "network-only",
      });
      const roleAccess = (accessResult.data && accessResult.data.getRoleModuleAccess) || [];
      localStorage.setItem("roleModuleAccess", JSON.stringify(roleAccess));

      // Role-based menu: when the user has a configured role, the sidebar must show
      // ONLY the modules that role is granted (is_view) — and only among the modules
      // this college has access to (getRoleModuleAccess already restricts the list to
      // the institute's accessible modules). We translate that into the SAME
      // `moduleRestrictions` shape the sidebar already reads (key === false => visible),
      // so no other module/menu logic changes.
      // Guard: only override when the user actually has a role AND that role grants at
      // least one viewable module. Otherwise leave the institute-level access as-is, so
      // admins and roles without configured access are unaffected (no impact).
      // The main college login (institute admin, employee_type_id / userlevel === 1) must
      // ALWAYS see the full set of the college's accessible modules — never the
      // role-restricted subset — even if that admin happens to have a role assigned.
      const isAdmin = parseInt(userData.userlevel) === 1;
      const hasRole = userData.employee_role_id && parseInt(userData.employee_role_id) > 0;
      if (isAdmin) {
        // Main college login: show the college's enabled modules for this
        // employee_type + institute (getModulesByEmployeeType returns only the
        // accessible ones). Build moduleRestrictions with every returned module
        // visible (key === false). If it returns nothing, leave the raw
        // module_access from login as-is.
        const typeResult = await client.query({
          query: GET_MODULES_BY_EMPLOYEE_TYPE,
          variables: {
            institute_id: parseInt(userData.institution_id),
            employee_type_id: parseInt(userData.userlevel),
          },
          fetchPolicy: "network-only",
        });
        const typeModules = (typeResult.data && typeResult.data.getModulesByEmployeeType) || [];
        if (typeModules.length > 0) {
          const effective = {};
          typeModules.forEach((r) => {
            effective[r.module_name] = false; // false = visible in sidebar
          });
          localStorage.setItem("moduleRestrictions", JSON.stringify(effective));
        }
      } else if (hasRole && roleAccess.length > 0) {
        const effective = {};
        roleAccess.forEach((r) => {
          const canView = r.is_view === true || r.is_view === 1 || r.is_view === "1";
          effective[r.module_name] = canView ? false : true; // false = visible in sidebar
        });
        const anyVisible = Object.values(effective).some((v) => v === false);
        if (anyVisible) {
          localStorage.setItem("moduleRestrictions", JSON.stringify(effective));
        }
      }
    } catch (accessError) {
      console.error("Error fetching role module access:", accessError);
      localStorage.setItem("roleModuleAccess", JSON.stringify([]));
    }

    // Fetch organisation profile and store address & url (logo) in cookies
    try {
      const orgResult = await client.query({
        query: GET_ORGANISATION_PROFILE,
        variables: { institution_id: parseInt(userData.institution_id) },
        fetchPolicy: "network-only",
      });
      const org = orgResult.data && orgResult.data.getOrganisationProfile;
      if (org) {
        Cookies.set("address", org.complete_address || "");
        Cookies.set(
          "url",
          org.logo ? `https://support.rizee.in/files/${org.logo}` : ""
        );
      }
    } catch (orgError) {
      console.error("Error fetching organisation profile:", orgError);
    }

    this.setState({ loader: 0 });
    if (result.data.login1) {
      // ── OLD CODE (kept for reference / rollback) ──────────────────────────
      // Everyone landed on the Dashboard, whether their role could see it or not.
      // A user without Dashboard access got a 403 as their first screen.
      //
      // this.props.history.push("/dashboard");

      // ── NEW CODE ─────────────────────────────────────────────────────────
      // Land on the first module this role actually has View access to. Derived from
      // the roleModuleAccess rows we just wrote to localStorage above, so it reflects
      // THIS user's grants. Dashboard is first in the list, so users who have it still
      // land there — unchanged for them.
      this.props.history.push(getFirstAccessibleRoute());
    }
  };
  handleInputChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  };
  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let usernameValid = this.state.usernameValid;
    let passwordValid = this.state.passwordValid;

    switch (fieldName) {
      case "username":
        var pattern = new RegExp(
          /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
        );

        if (value.length < 4) {
          usernameValid = false;
          fieldValidationErrors.username =
            "Username cannot be less than 5 chars";
        }
        // else if (!pattern.test(value)) {
        //   usernameValid = false;
        //   fieldValidationErrors.username = "Invalid Username";
        // } 
        else {
          usernameValid = true;
          fieldValidationErrors.username = "";
        }

        break;
      case "password":
        if (value.length == "") {
          passwordValid = false;
          fieldValidationErrors.password = "Password cannot be Empty";
        } else {
          passwordValid = true;
          fieldValidationErrors.password = "";
        }

        break;

      default:
        break;
    }
    this.setState(
      {
        formErrors: fieldValidationErrors,
        usernameValid: usernameValid,
        passwordValid: passwordValid
      },
      this.validateForm
    );
  }

  validateForm() {
    this.setState({
      formValid: this.state.passwordValid || this.state.usernameValid
    });
    if (this.state.formValid) {
      this.setState({ submitError: "" }, () => { });
    }
  }

  render() {
    // Users arriving on the Vignan subdomain (or via the ?vignan=1 local-testing
    // override) get a separate, Vignan-branded login.
    if (isVignanContext()) {
      return <VignanLogin />;
    }

    // Already logged in and back on /login → bounce them into the app.
    //
    // ── OLD CODE (kept for reference / rollback) ──────────────────────────────
    // Hardcoded to Manage Exams, a module most roles cannot see — so a user who
    // revisited /login was thrown at a page they had no right to, and now that the
    // URL guard is active, straight at an Access Denied screen.
    //
    // this.props.history.push("/questions/manage-question-paper");

    // ── NEW CODE ─────────────────────────────────────────────────────────────
    // Same landing logic as a fresh login: their first View-accessible module.
    if (
      Cookies.get("token") != undefined &&
      Cookies.get("institutionid") != undefined
    ) {
      this.props.history.push(getFirstAccessibleRoute());
    }


    return (
      <div className="login_new_design">
        <header className="header-one">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <a href="https://rizee.in/"><img className="img-fluid rizee_logo  p-2 mt-4 center-res-img" src={require('../../images/rizee_logo.png')} alt="Logo" /></a>
              </div>
            </div>
          </div>
        </header>
        <section className="banner_blue">
          <div className="container">
            <div className="row">
              <div className="col-sm-8">
                <Card className="text-white card_transparent">
                  <Card.Img src={require('../../images/blub.png')} className="width_blub_img image-color-change center-img" alt="Card image" />
                  <Card.ImgOverlay>
                    <Card.Title className="f-75 mt-5 res_hide" style={{ color: "#fff" }}>Welcome,<br />Launch your <span class="color_yellow">Institute</span> <br />Live Exams with <span class="color_yellow">RIZEE</span></Card.Title>
                    <Card.Title className="f-60 mt-4 res_show" style={{ color: "#fff" }}>Welcome, <span className="font_align">Launch your Live <span class="color_yellow">Institute</span> Exams with <span class="color_yellow">RIZEE</span></span></Card.Title>
                  </Card.ImgOverlay>
                </Card>
              </div>
              <div className="col-sm-4">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="white_block">

                      <Form>
                        {this.state.currentStep == 5 ? (
                          <Form.Text className="form-text text-danger">
                            You are successfully loggedIn
                          </Form.Text>
                        ) : (
                          <Form.Text className="form-text text-danger">
                            {this.state.submitError}
                          </Form.Text>
                        )}
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label className="font-weight-bold f-16 color_yash"> <i className="far fa-envelope mr-2" /> UserName / Email</Form.Label>
                          <Form.Control type="text" className="input_custom" placeholder="Enter Name" onChange={this.handleInputChange} name="username" />
                          <Form.Text className="form-text text-danger">
                            {this.state.formErrors.username}
                          </Form.Text>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicPassword">
                          <Form.Label className="font-weight-bold f-16 color_yash"> <i className="fas fa-lock mr-2" /> Password</Form.Label>
                          <div style={{ position: "relative" }}>
                            <Form.Control type={this.state.showPassword ? "text" : "password"} className="input_custom" placeholder="Password" onChange={this.handleInputChange} name="password" />
                            <i
                              className={`fas ${this.state.showPassword ? "fa-eye-slash" : "fa-eye"}`}
                              onClick={this.togglePasswordVisibility}
                              style={{ position: "absolute", right: "15px", top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "#888" }}
                            />
                          </div>
                          <Form.Text className="form-text text-danger">
                            {this.state.formErrors.password}
                          </Form.Text>
                        </Form.Group>

                        {this.state.loader == 1 ? (
                          <Button className="btn-block btn-light-blue" type="submit" block disabled style={{ width: "" }}>
                            <span className="spinner-border spinner-border-sm"></span>
                            logging..
                          </Button>
                        ) : (
                          <Button onClick={this.handleFormSubmit} className="btn-block btn-light-blue" type="submit" block>
                            Login <i class="fas fa-long-arrow-alt-right ml-3"></i>
                          </Button>
                        )}

                        <h6 className="text-center mt-4 color_yash">Don't have an account? <a href="https://rizee.in/college/?src=CEmail" className="color_black font-weight-bold">Register</a></h6>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="bg_white mt-res-10">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 mt-5 mb-4 res_hide">
                <img className="width_blub_glow_img center-img" src={require('../../images/blub_glow.png')} alt="blub_glow" />
              </div>
              <div className="col-sm-6 mt-5 mb-4">
                <h2 className="text-center-res">Monitor your Students in Realtime with Rizee</h2>
                <ul className="list-inline custom_list_css mt-4">
                  <li>
                    All Services that students see are under your <b>Institute Name</b>
                  </li>
                  <li>
                    Create your own <b>Questions & Content library</b>
                  </li>
                  <li>
                    <b>Auto - Generated</b> Question Papers in latest patterns
                  </li>
                  <li>
                    <b>Smart features</b> to save your time & efforts
                  </li>
                  <li>
                    Explore Student & Teacher <b>Activity reports</b>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="mt-res-5 mb-res-5 bg_light_green">
          <div className="container res_hide">
            <div className="row justify-content-center">
              <div className="col-sm-9">
                <div className="white_block_new">
                  <h2 className="text-center mt-3">Everything you Need is in Rizee</h2>
                  <div className="row">
                    <div className="col-sm-6">
                      <ul className="list-inline custom_list_icons mt-4">
                        <li>
                          <img className="" src={require('../../images/icon1.png')} alt="icon" /> <span>Make Your Online Presence Felt all over India</span>
                        </li>
                        <li>
                          <img className="" src={require('../../images/icon2.png')} alt="icon" /> <span>One Solution For Online or Offline Exams</span>
                        </li>
                        <li>
                          <img className="" src={require('../../images/icon3.png')} alt="icon" /> <span>Manage Student and Faculty Data</span>
                        </li>
                        <li>
                          <img className="" src={require('../../images/icon4.png')} alt="icon" /> <span>Manage your organisation From One Platform</span>
                        </li>

                      </ul>
                    </div>
                    <div className="col-sm-6">
                      <ul className="list-inline custom_list_icons mt-4">
                        <li>
                          <img className="" src={require('../../images/icon5.png')} alt="icon" /> <span>Notify Students For Each Activity</span>
                        </li>
                        <li>
                          <img className="" src={require('../../images/icon6.png')} alt="icon" /> <span>Improve Your Admission Process with Us</span>
                        </li>
                        <li>
                          <img className="" src={require('../../images/icon7.png')} alt="icon" /> <span>Make Exam Creation Easy For You</span>
                        </li>
                        <li>
                          <img className="" src={require('../../images/icon8.png')} alt="icon" /> <span>Monitor Each Students Exam Report</span>
                        </li>

                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="res_show container">
            <div className="row">
              <div className="col-sm-12">
                <h2 className="text-center mt-4">Everything you Need is in Rizee</h2>
                <ul className="list-inline custom_list_icons mt-4">
                  <li>
                    <img className="" src={require('../../images/icon1.png')} alt="icon" /> <span>Make Your Online Presence Felt all over India</span>
                  </li>
                  <li>
                    <img className="" src={require('../../images/icon2.png')} alt="icon" /> <span>One Solution For Online or Offline Exams</span>
                  </li>
                  <li>
                    <img className="" src={require('../../images/icon3.png')} alt="icon" /> <span>Manage Student and Faculty Data</span>
                  </li>
                  <li>
                    <img className="" src={require('../../images/icon4.png')} alt="icon" /> <span>Manage your organisation From One Platform</span>
                  </li>
                  <li>
                    <img className="" src={require('../../images/icon5.png')} alt="icon" /> <span>Notify Students For Each Activity</span>
                  </li>
                  <li>
                    <img className="" src={require('../../images/icon6.png')} alt="icon" /> <span>Improve Your Admission Process with Us</span>
                  </li>
                  <li>
                    <img className="" src={require('../../images/icon7.png')} alt="icon" /> <span>Make Exam Creation Easy For You</span>
                  </li>
                  <li>
                    <img className="" src={require('../../images/icon8.png')} alt="icon" /> <span>Monitor Each Students Exam Report</span>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="bg_blue_light">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 mt-5 mb-4">
                <img className="width_blub_glow_img center-img" src={require('../../images/contact_college.png')} alt="contact_college" />
              </div>
              <div className="col-sm-6 mt-6 mb-4">
                <h2 className="color_white text-center">Contact Us</h2>
                <h5 className="text-center mt-4"><span className="white_border"><i class="fab fa-whatsapp"></i> <i class="fas fa-phone-alt"></i>+91 91541-10191</span></h5>
              </div>
            </div>
          </div>
        </section>
        <footer>
          <p className="text-center">&copy; 2026 Rizee Web App. All rights reserved</p>
        </footer>
      </div>
    );
  }
}
export default withRouter(
  graphql(LOGIN_USER, {
    name: "login1"
  })(Login)
);
